import styled from 'styled-components';
import Toggler from '@minecraft.toggler';

export const FilterBasicContainer = styled.div`
  ${Toggler.StyledTogglerContainer} {
    border: none;
    padding: 0;
  }

  ${Toggler.StyledTogglerItem} {
    &:first-child {
      flex: 1 0 auto;
    }
  }
`;
